import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoDynamicFormField, PoLookupColumn, PoNotificationService, PoTableColumn, PoTableComponent } from '@po-ui/ng-components';
import { Cliente } from 'src/app/interface/cliente';
import { defaultPedidoItemExpedicaoDtoLista, PedidoItemExpedicaoDto, PedidoItemExpedicaoDtoLista } from '../../romaneio/interface/romaneio';
import { RomaneioService } from '../../romaneio/service/romaneio.service';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';

@Component({
  selector: 'app-liberacao-pedido-expedicao',
  templateUrl: './liberacao-pedido-expedicao.component.html',
  styleUrls: ['./liberacao-pedido-expedicao.component.css']
})
export class LiberacaoPedidoExpedicaoComponent implements OnInit {

  codigoCliente: string = '';

  advancedClienteFilters: Array<PoDynamicFormField>;
  columnsClienteFilters: Array<PoLookupColumn>;
  fieldFormaterClienteFilters: ((value: Cliente) => string);

  tabelaPrincipalItens: Array<PedidoItemExpedicaoDto> = [];
  itensAux: Array<PedidoItemExpedicaoDto> = [];
  itensLiberar: PedidoItemExpedicaoDtoLista;

  constructor(
    public clienteLookupService: ClienteLookupService,
    private romaneioService: RomaneioService,
    private poNotificationService: PoNotificationService,
    private poDialog: PoDialogService,
    private router: Router,
  ) {

    this.advancedClienteFilters = this.clienteLookupService.getAdvancedFilter();
    this.columnsClienteFilters = this.clienteLookupService.getColumnsFilter();
    this.fieldFormaterClienteFilters = this.clienteLookupService.getFieldFormater;

    this.itensLiberar = defaultPedidoItemExpedicaoDtoLista();
  }

  @ViewChild('poTablePrincipal', { static: true }) poTablePrincipal!: PoTableComponent;

  ngOnInit(): void {
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CZ02COD'    , label: 'Etq Expedição'    , width: '8%'},
    {property: 'CZ02LOTE'   , label: 'Lote'             , width: '9%'},
    {property: 'CZ02CODZ00' , label: 'Código Romaneio'  , width: '13%'},
    {property: 'NZ01QUANT'  , label: 'Qtd Expedição'    , width: '8%'},
    {property: 'CC5NUM'     , label: 'Pedido'           , width: '7%'},
    {property: 'DC5EMISSAO' , label: 'Emissão'          , width: '10%', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CC6ITEM'    , label: 'Item do Pedido'   , width: '10%'},
    {property: 'CC6PRODUTO' , label: 'Produto'          , width: '10%'},
    {property: 'CC6DESCRI'  , label: 'Descrição Produto', width: '22%'},
    {property: 'NC6QTDVEN'  , label: 'Qtd Pedido'       , width: '8%'},
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Expedição', action: this.goTo.bind(this) },
      { label: 'Alterar Pedido' }
    ]
  };

  goTo(): void {
    this.router.navigateByUrl('');
  }

  clienteSelecionado(row: Cliente) {
    this.romaneioService.listaPedidosCliente(this.codigoCliente).subscribe((ret) => {
      this.tabelaPrincipalItens = ret.items.map((item) => {
        return {...item, qtdVinculadaEtiqueta: 0, qtdVinculadaItem: 0};
      });
      this.itensAux = this.tabelaPrincipalItens;
    });
  }

  liberarPedidos() {
    const selectedItems = this.poTablePrincipal.getSelectedRows();

    if (selectedItems.length > 0) {
      this.itensLiberar = defaultPedidoItemExpedicaoDtoLista();
      this.itensLiberar.items = selectedItems.map((item) => {
        return {...item};
      });

      this.poDialog.confirm({
        title: 'Liberar Pedidos',
        message: `Deseja realizar a liberação dos pedidos selecionados?`,
        confirm: () => this.confirmarExpedicao(),
        cancel: () => {}
      });
    }
  }

  confirmarExpedicao(): void {
    /*
    this.romaneioService.liberarPedidos(this.itensLiberar).subscribe(() => {
      this.poNotificationService.success("Pedidos Liberados com Sucesso!");
      this.codigoCliente = '';
      this.itens = [];
    });
    */
  }

  verificaSomaEtiqueta(row: PedidoItemExpedicaoDto): void {
    this.itensAux = this.itensAux.map((item) => {
      if (row.CZ02COD == item.CZ02COD) {
        item.qtdVinculadaEtiqueta += row.NZ01QUANT;
        if (row.CC6ITEM == item.CC6ITEM) {
          item.qtdVinculadaItem += row.NZ01QUANT;
        }
      }
      return {...item};
    });

    this.tabelaPrincipalItens = this.itensAux.filter((item) => {
      return (item.qtdVinculadaItem > 0 || item.qtdVinculadaEtiqueta < row.NZ01QUANT);
    });
  }

  verificaSubtracaoEtiqueta(row: PedidoItemExpedicaoDto): void {
    this.itensAux = this.itensAux.map((item) => {
      if (row.CZ02COD == item.CZ02COD) {
        item.qtdVinculadaEtiqueta -= row.NZ01QUANT;
        if (row.CC6ITEM == item.CC6ITEM) {
          item.qtdVinculadaItem -= row.NZ01QUANT;
        }
      }
      return {...item};
    });

    this.tabelaPrincipalItens = this.itensAux.filter((item) => {
      return (item.qtdVinculadaItem > 0 || item.qtdVinculadaEtiqueta < row.NZ01QUANT);
    });
  }


}
